import * as React from "react";
import useHasEntityOwnership from "hooks/useHasEntityOwnership";
const HasOwnership = ({ children, id = void 0, type, hideChildren = false }) => {
  const hasOwnership = useHasEntityOwnership(id, type);
  if (typeof children !== "function") {
    throw new Error('Invalid prop: "children" must be a function.');
  }
  if (hideChildren) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children({ disabled: !hasOwnership }), " ");
};
export default HasOwnership;
